import fastdom from 'fastdom';
import { hasClass, isEmpty, isFunction } from 'mc-ui-utils';
import { getViewPortDimensions } from './common';
/**
 * [getPosition returns a position element that works for mouse or touch events]
 * @param  {[Event]} event [the received event]
 * @return {[Object]}      [x and y coords]
 */
export const getPosition = (event) => {
    if ('touches' in event) {
        const { screenX, pageY } = event.touches[0];
        return { x: screenX, y: pageY };
    }
    const { screenX, screenY } = event;
    return { x: screenX, y: screenY };
};
export const getTranslateX = (element) => {
    const style = window.getComputedStyle(element);
    const matrix = new WebKitCSSMatrix(style.transform);
    return matrix.m41;
};
let supportsCaptureOption = false;
export const setHasSupportToCaptureOption = (hasSupport) => {
    supportsCaptureOption = hasSupport;
};
try {
    addEventListener('test', null, Object.defineProperty({}, 'capture', {
        get: function get() {
            setHasSupportToCaptureOption(true);
        },
    }));
}
catch (e) { } // eslint-disable-line no-empty
export const getSafeEventHandlerOpts = (options = { capture: true }) => {
    return supportsCaptureOption ? options : options.capture;
};
const capture = true;
const passive = true;
export const addListeners = (element, { onSwipeStart, onSwipeMove, onSwipeEnd }) => {
    if (isFunction(onSwipeStart)) {
        element.addEventListener('touchstart', onSwipeStart, getSafeEventHandlerOpts({
            capture,
            passive,
        }));
    }
    if (isFunction(onSwipeMove)) {
        element.addEventListener('touchmove', onSwipeMove, getSafeEventHandlerOpts({
            capture,
            passive,
        }));
    }
    if (isFunction(onSwipeEnd)) {
        element.addEventListener('touchend', onSwipeEnd, getSafeEventHandlerOpts({
            capture,
            passive,
        }));
    }
};
export const removeListeners = (element, { onSwipeStart, onSwipeMove, onSwipeEnd }) => {
    if (isFunction(onSwipeStart)) {
        element.removeEventListener('touchstart', onSwipeStart, getSafeEventHandlerOpts({
            capture,
            passive,
        }));
    }
    if (isFunction(onSwipeMove)) {
        element.removeEventListener('touchmove', onSwipeMove, getSafeEventHandlerOpts({
            capture,
            passive,
        }));
    }
    if (isFunction(onSwipeEnd)) {
        element.removeEventListener('touchend', onSwipeEnd, getSafeEventHandlerOpts({
            capture,
            passive,
        }));
    }
};
export const swipeAnimateCards = (amountSwiped) => {
    const deltaInPercentage = (amountSwiped / parseInt(getViewPortDimensions().vw, 10)) * 100;
    if (amountSwiped < 0) {
        const currentCard = document.querySelector('.current');
        const COACHMARK_CLASS = 'has-coachmark';
        if (!isEmpty(currentCard)) {
            if (hasClass(currentCard, COACHMARK_CLASS)) {
                currentCard.classList.remove(COACHMARK_CLASS);
            }
            clearAnimatingStyles(document.querySelector('.prev'));
            fastdom.mutate(() => {
                currentCard.style.cssText = `transition: none;transform: translate3d(${deltaInPercentage}%, 0, 1px);`;
            });
        }
    }
    else {
        const prev = document.querySelector('.prev');
        if (!isEmpty(prev)) {
            clearAnimatingStyles(document.querySelector('.current'));
            fastdom.mutate(() => {
                prev.style.cssText = `transition: none;transform: translate3d(-${100 - deltaInPercentage}%, 0, 2px);`;
            });
        }
    }
};
export const resetCards = () => {
    clearAnimatingStyles(document.querySelector('.current'));
    clearAnimatingStyles(document.querySelector('.prev'));
};
export const clearAnimatingStyles = (card) => {
    if (!isEmpty(card) && card instanceof HTMLElement) {
        fastdom.mutate(() => {
            card.style.cssText = '';
        });
    }
};
export const getSlideClassName = (currentGlanceIndex, index, hasCoachMark) => {
    switch (true) {
        case currentGlanceIndex === index: {
            const classes = ['current'];
            if (hasCoachMark) {
                classes.push('has-coachmark');
            }
            return classes.join(' ');
        }
        case index === currentGlanceIndex + 1:
            return 'next';
        case index === currentGlanceIndex - 1:
            return 'prev';
        case index === currentGlanceIndex - 2:
            return 'prev2';
    }
};
export const checkCardVisible = (currentGlanceIndex, index) => {
    if (currentGlanceIndex === index ||
        index === currentGlanceIndex + 1 ||
        index === currentGlanceIndex - 1) {
        return true;
    }
    return false;
};
export const isBeingSwiped = () => {
    var _a, _b;
    const card = document.querySelector('.current');
    const prev = document.querySelector('.prev');
    return !isEmpty((_a = card === null || card === void 0 ? void 0 : card.style) === null || _a === void 0 ? void 0 : _a.transform) || !isEmpty((_b = prev === null || prev === void 0 ? void 0 : prev.style) === null || _b === void 0 ? void 0 : _b.transform);
};
//# sourceMappingURL=slider.js.map